import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as usageActions from '../../modules/usage/actions';
import * as billingActions from '../../modules/billing/actions';
import moment from 'moment';
import businessProducts from '../../utils/products';
import _ from 'lodash';
import styled from 'styled-components';
import { makeSelectFetchingBilling, makeSelectFetchingUsage, makeSelectSubUsage, makeSelectFetchingSubUsage, makeSelectAllUsages } from '../../modules/usage/selectors';
import { selectCustomerData } from '../../modules/customer/selectors';
import { getAccountId } from '../../utils/helpers';
import { makeSelectActiveBillingPeriod, makeSelectBillingPeriods } from '../../modules/billing/selectors';
import { BillingPeriodSelect } from '../../components/BillingPeriodSelect';
import { ContactListRow } from './ContactListRow';

const Container = styled.div`
	overflow: auto;
`;

const SelectContainer = styled.div`
	float: right;
	max-width: 15.5rem;
	margin-left: 1rem;
	max-height: 2rem;
	text-align: center;
	margin-bottom: 2em;
`;

const SimListWrapper = styled.div`
	width: 100%;
	margin: auto;
	margin-bottom: 2em;
	overflow: hidden;
	font-size: 1em;
	color: gray;
	span {
		color: gray;
		font-size: 1em;
		margin-top: 0.7em;
		display: inline-block;
		height: 2.5em;
	}
`;

class SimList extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			simsCombined: false,
			simsWithData: null,
			billingPeriodLength: null,
			daysIntoBillingPeriod: null
		};
	}

	componentDidMount() {
		const { initializeAllUsages, allUsagesData, activeBillingPeriod, fetchAllUsages, fetchingUsage } = this.props;
		if (_.isEmpty(allUsagesData) && _.isEmpty(activeBillingPeriod) && !fetchingUsage) {
			initializeAllUsages(getAccountId());
		} else if (activeBillingPeriod && !fetchingUsage) {
			fetchAllUsages(getAccountId(), activeBillingPeriod.startDate, activeBillingPeriod.endDate);
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { fetchAllUsages, allUsagesData } = this.props;
		if (nextProps.activeBillingPeriod !== null && nextProps.activeBillingPeriod && !allUsagesData && !_.isEqual(nextProps.activeBillingPeriod, this.props.activeBillingPeriod)) {
			fetchAllUsages(getAccountId(), nextProps.activeBillingPeriod.startDate, nextProps.activeBillingPeriod.endDate);
		}
		if (
			nextProps.sims &&
			nextProps.allUsagesData &&
			(!_.isEqual(nextProps.allUsagesData, this.props.allUsagesData) || this.state.simsWithData == null || !_.isEqual(nextProps.sims, this.props.sims)) &&
			!nextProps.fetchingUsage
		) {
			this.setSimsWithData(nextProps.sims, nextProps.allUsagesData.toJS());
		}
	}

	// TODO: testaa, näyttäisi mahdolliselta syylliseltä Moi:n tilillä olevaan erroriin
	getSimWithData = (sim, allUsagesData) => {
		if (_.isNil(allUsagesData)) {
			return {
				...sim
			};
		}
		return {
			...sim,
			...allUsagesData.analysedSubscriptionUsages.find((usage) => usage.subscriptionNumber === sim.id)
		};
	};

	setSimsWithData = (sims, allUsagesData) => {
		const simsArr = [];
		sims.forEach((sim) => {
			simsArr.push(this.getSimWithData(sim, allUsagesData));
		});
		this.setState({
			simsCombined: true,
			simsWithData: simsArr
		});
	};

	getSimsAsList = (simsWithData) => {
		if (!_.isNil(simsWithData)) {
			return simsWithData;
		}
		return this.props.sims;
	};

	sortByData = (a, b) => {
		if (a.usedDomesticData === undefined) {
			return 1;
		}
		if (b.usedDomesticData === undefined) {
			return -1;
		}
		if (a.usedDomesticData < b.usedDomesticData) {
			return 1;
		}
		if (a.usedDomesticData > b.usedDomesticData) {
			return -1;
		}
		return 0;
	};

	sortByVoice = (a, b) => {
		if (a.usedDomesticCalls === undefined) {
			return 1;
		}
		if (b.usedDomesticCalls === undefined) {
			return -1;
		}
		if (a.usedDomesticCalls < b.usedDomesticCalls) {
			return 1;
		}
		if (a.usedDomesticCalls > b.usedDomesticCalls) {
			return -1;
		}
		return 0;
	};

	sortByMessage = (a, b) => {
		if (a.usedDomesticSms === undefined) {
			return 1;
		}
		if (b.usedDomesticSms === undefined) {
			return -1;
		}
		if (a.usedDomesticSms < b.usedDomesticSms) {
			return 1;
		}
		if (a.usedDomesticSms > b.usedDomesticSms) {
			return -1;
		}
		return 0;
	};

	sortBySelection = (simsArray) => {
		if (this.props.selectedSort === 'data') {
			simsArray.sort(this.sortByData);
		} else if (this.props.selectedSort === 'voice') {
			simsArray.sort(this.sortByVoice);
		} else if (this.props.selectedSort === 'message') {
			simsArray.sort(this.sortByMessage);
		}
		return simsArray;
	};

	updateBillingPeriod = (billingPeriod) => {
		const { setActiveBillingPeriod, fetchAllUsages } = this.props;
		const start = moment(billingPeriod.startDate);

		const daysFromStart = moment().diff(start, 'days');
		const periodLength = businessProducts.getEstimatePeriodLength(billingPeriod.startDate, billingPeriod.endDate);

		this.setState({
			selectedBillingPeriod: {
				startDate: billingPeriod.startDate,
				endDate: billingPeriod.endDate
			},
			billingPeriodLength: periodLength,
			daysIntoBillingPeriod: Math.min(daysFromStart, periodLength),
			simsWithData: null
		});
		setActiveBillingPeriod(billingPeriod);
		fetchAllUsages(getAccountId(), billingPeriod.startDate, billingPeriod.endDate);
	};

	render() {
		const { allUsagesData, billingPeriods, activeBillingPeriod, accountType, offeringType } = this.props;
		return (
			<Container>
				{billingPeriods && accountType === 'business' && allUsagesData && (
					<SelectContainer>
						<BillingPeriodSelect billing={billingPeriods} selectedBillingPeriod={activeBillingPeriod || billingPeriods[0]} sendPeriod={this.updateBillingPeriod} disabled={this.props.fetchingUsage} />
					</SelectContainer>
				)}
				<SimListWrapper>
					{this.sortBySelection(this.getSimsAsList(this.state.simsWithData)).map((sim, index) => (
						<ContactListRow
							key={index}
							index={index}
							{...sim}
							{...this.state}
							withData={accountType === 'business'}
							packageType={accountType === 'consumer' ? sim.productPackageType : null}
							offeringType={offeringType}
						/>
					))}
				</SimListWrapper>
			</Container>
		);
	}
}

SimList.propTypes = {
	accountType: PropTypes.string,
	initializeAllUsages: PropTypes.func,
	allUsagesData: PropTypes.object,
	setActiveBillingPeriod: PropTypes.func,
	selectedSort: PropTypes.string,
	billingPeriods: PropTypes.array,
	activeBillingPeriod: PropTypes.object,
	fetchAllUsages: PropTypes.func,
	sims: PropTypes.array,
	fetchingUsage: PropTypes.bool,
	offeringType: PropTypes.string
};

const makeMapStateToProps = () => {
	const selectFetchingBilling = makeSelectFetchingBilling();
	const selectFetchingUsage = makeSelectFetchingUsage();
	const selectBillingPeriods = makeSelectBillingPeriods();
	const selectUsageData = makeSelectSubUsage();
	const selectFetchingSubUsage = makeSelectFetchingSubUsage();
	const selectAllUsages = makeSelectAllUsages();
	const selectActiveBillingPeriod = makeSelectActiveBillingPeriod();

	return (state) => ({
		fetching: selectFetchingBilling(state),
		customer: selectCustomerData(state),
		fetchingUsage: selectFetchingUsage(state),
		billingPeriods: selectBillingPeriods(state),
		activeBillingPeriod: selectActiveBillingPeriod(state),
		// overall usage
		usageData: selectUsageData(state),
		allUsagesData: selectAllUsages(state),
		fetchingSubUsage: selectFetchingSubUsage(state)
	});
};

const mapDispatchToProps = {
	...billingActions,
	...usageActions
};

export default connect(makeMapStateToProps, mapDispatchToProps)(SimList);
